<template>
  <b-button @click="$emit('click', $event)" size="sm" :variant="variant" v-b-tooltip.hover :title="showToolTip ? tooltip : ''"><i class="fa fa-plus"></i></b-button>
</template>

<script>


export default ({
  name: "button-add",

  props: {
    variant: {
      type: String,
      default: 'warning'
    },
    tooltip: {
      type: String,
      default: 'Добавить'
    },
  },

  computed: {
    showToolTip() {
      return this.$store.state.userSettings.showTooltips
    }
  }
})
</script>
